/**
 * Maps a test-generation failure onto user-facing copy.
 *
 * The generators in @petergok/blue-collar-shared signal failure by throwing
 * descriptive messages rather than returning a short test, so the app matches
 * on those messages to choose copy.
 *
 * Matching on message substrings is fragile — these strings are thrown from a
 * different repo, so a reword there silently degrades this to the generic
 * message with no test to catch it. A `code` field on the shared errors would
 * be the real fix; this mirrors the same mapping used by BlueCollarApp so the
 * two clients stay consistent until then.
 */

type Translate = (key: string) => string;

export function getStartTestFailureMessage(
  error: unknown,
  t: Translate,
): string {
  if (error instanceof Error) {
    const { message } = error;

    // Both mean "the content can't satisfy this request", from the standard
    // and quick-practice generators respectively.
    if (
      message.includes("Question pool exhausted") ||
      message.includes("No sections with questions")
    ) {
      return t("study.start_test_pool_exhausted");
    }
  }

  // Includes "Failed to generate quick practice exam after 10 tries", which is
  // genuinely retryable — the generic "please try again" is the right copy.
  return t("study.start_test_failed");
}
